module.exports = __webpack_public_path__ + "static/img/calendar-time.fbc84e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calendar-time.svg
// module id = jV7j
// module chunks = 1